export default (pixelAllowedRoutes: string[], currentLocation: string): boolean =>
  !!pixelAllowedRoutes.filter((route) => currentLocation.includes(route)).length;
